import type { IDocument } from "@bbj-types/document";
import type { ObjectId } from "@bbj-types/utils";
import { Box, Stack, Typography } from "@mui/material";
import { SuspenseHandler } from "@navigations/SuspenseHandler";
import type { Dispatch, SetStateAction } from "react";
import { MailPreview } from "./mailPreview";
import { MailTemplate } from "./mailTemplate";

interface ISendMailModalMailContentBodyProps {
  template: IDocument | null;
  setTemplate: Dispatch<SetStateAction<IDocument | null>>;
  templatePreviewLoading: boolean;
  setTemplatePreviewLoading: Dispatch<SetStateAction<boolean>>;
  getMailPreview: (templateId: ObjectId) => Promise<string | undefined>;
  getMailTemplates: () => IDocument[];
}

export const SendMailModalMailContentBody = ({
  template,
  setTemplate,
  templatePreviewLoading,
  setTemplatePreviewLoading,
  getMailPreview,
  getMailTemplates,
}: ISendMailModalMailContentBodyProps) => {
  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography variant="subtitle1SemiBold" color="primary">
        Contenu
      </Typography>
      <Stack
        sx={{
          gap: 1,
        }}
      >
        <Typography>
          Sélectionnez le courrier type ci-dessous pour voir apparaître un exemple du courrier qui sera envoyé.
        </Typography>
        <Box
          sx={{
            position: "relative",
            height: 40,
          }}
        >
          <SuspenseHandler>
            <MailTemplate template={template} setTemplate={setTemplate} getMailTemplates={getMailTemplates} />
          </SuspenseHandler>
        </Box>
        <MailPreview
          template={template}
          templatePreviewLoading={templatePreviewLoading}
          setTemplatePreviewLoading={setTemplatePreviewLoading}
          getMailPreview={getMailPreview}
        />
      </Stack>
    </Stack>
  );
};
